import React from 'react'
import { IconSizes } from './iconConstants'

export interface IconWrapperProps {
    children?: React.ReactNode
    size?: IconSizes
}

export const IconWrapper = ({ children, size = IconSizes.MEDIUM, ...props }: IconWrapperProps) => {
    const mappedChildren = React.Children.map(children, (element) => {
        if (React.isValidElement(element)) {
            return React.cloneElement(element, {
                // @ts-ignore
                width: size,
                height: size,
                ...props,
            })
        }
        return element
    })

    return <span className={`icon-wrapper icon-wrapper--size-${size}`}>{mappedChildren}</span>
}
